<script>

import { Overlay } from '../../'

export default {
    name: 'StochasticRSI',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Stochastic RSI - Applies Stochastic oscillator to RSI values',
                preset: {
                    name: 'StochRSI $rsi_length $stoch_length $smooth_k $smooth_d',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#2196f3',
                        signalColor: '#ff5722'
                    }
                }
            }
        },
        use_for() { return ['StochasticRSI'] },
        calc() {
            return {
                props: {
                    rsi_length: { def: 14, text: 'RSI Length' },
                    stoch_length: { def: 14, text: 'Stochastic Length' },
                    smooth_k: { def: 3, text: 'Smooth K' },
                    smooth_d: { def: 3, text: 'Smooth D' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let strength = rsi(close, rsi_length)
                    let upper = highest(strength, stoch_length)[0]
                    let lower = lowest(strength, stoch_length)[0]
                    let raw = ts(upper === lower ? 50 : 100 * (strength[0] - lower) / (upper - lower))
                    let k = sma(raw, smooth_k)
                    let d = sma(k, smooth_d)
                    return [k[0], d[0]]
                `
            }
        }
    }
}
</script>
